import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import context from '../context/recipesContext';
import drinksDetailsAPI from '../services/drinksDetailsAPI';
import whiteHeartIcon from '../images/whiteHeartIcon.svg';
import blackHeartIcon from '../images/blackHeartIcon.svg';
import ShareButton from './ShareButton';
import '../pages/css/FoodDetails.css';

function ListDetailsDrinks({ id, pathname }) {
  const [drinks, setDrinks] = useState([]);
  const [checkbox, setCheckbox] = useState(false);

  const { arrayIngredients,
    ingredients,
    changeFavoriteButton,
    favorite,
    setFavorite,
    favoriteRecipes,
    checked,
    setChecked,
  } = useContext(context);

  const {
    strDrinkThumb,
    strDrink,
    strAlcoholic,
    strInstructions,
    strCategory,
  } = drinks;

  const favoriteDrinks = {
    id,
    type: 'drink',
    nationality: '',
    category: strCategory,
    alcoholicOrNot: strAlcoholic,
    name: strDrink,
    image: strDrinkThumb,
  };

  const checkboxIsVisible = () => {
    if (pathname.includes('/in-progress')) {
      setCheckbox(true);
    } else { setCheckbox(false); }
  };

  const favoriteRecipeDrinks = (e) => {
    e.preventDefault();
    if (favorite === false) {
      localStorage.setItem(
        'favoriteRecipes', JSON.stringify([...favoriteRecipes, favoriteDrinks]),
      );
    } else {
      const removeFavoriteRecipe = favoriteRecipes.filter((recipe) => recipe.id !== id);
      localStorage.setItem(
        'favoriteRecipes', JSON.stringify(removeFavoriteRecipe),
      );
    }
    setFavorite(!favorite);
  };

  const checkedIngredient = (e) => {
    const { name } = e.target;
    const filterChecked = checked.filter((ingredient) => ingredient !== name);
    if (e.target.checked) {
      setChecked((prevState) => [...prevState, name]);
    } else { setChecked(filterChecked); }
  };

  useEffect(() => {
    const fetchDrinks = async () => {
      const getDrinks = await drinksDetailsAPI(id);
      setDrinks(getDrinks);
      arrayIngredients(getDrinks);
    };
    fetchDrinks();
    changeFavoriteButton(id);
    checkboxIsVisible();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="details-content">
      <h1
        data-testid="recipe-title"
      >
        { strDrink }
      </h1>
      <img
        className="recipe-image"
        data-testid="recipe-photo"
        src={ strDrinkThumb }
        alt={ strDrink }
        width="200px"
      />
      <div className="d-buttons">
        <ShareButton id={ id } />
        <button
          type="button"
          onClick={ favoriteRecipeDrinks }
          className="b-favorite"
        >
          <img
            data-testid="favorite-btn"
            src={ favorite ? blackHeartIcon : whiteHeartIcon }
            alt="Favorite"
          />
        </button>
      </div>
      <h3 data-testid="recipe-category" className="t-info">
        {strAlcoholic}
      </h3>
      <div className="recipe-category">
        <h2>Ingredients</h2>
        <div className="check-list">
          { checkbox
            ? ingredients.map((ingredient, index) => (
              <div
                key={ index }
              >
                <label
                  htmlFor={ index }
                  data-testid={ `${index}-ingredient-step` }
                  className={ checked.includes(ingredient) ? 'lineThought' : undefined }
                >
                  <input
                    onChange={ (e) => checkedIngredient(e) }
                    type="checkbox"
                    className="i-item"
                    id={ index }
                    name={ ingredient }
                    defaultChecked={ checked.includes(ingredient) }
                  />
                  {ingredient}
                </label>
              </div>
            ))
            : ingredients.map((ingredient, index) => (
              <p
                data-testid={ `${index}-ingredient-name-and-measure` }
                key={ index }
              >
                {ingredient}
              </p>
            ))}
        </div>
      </div>
      <div className="instructions">
        <h2>Instructions</h2>
        <p data-testid="instructions">
          { strInstructions }
        </p>
      </div>
    </div>
  );
}

ListDetailsDrinks.propTypes = {
  id: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
};

export default ListDetailsDrinks;
